export const SET_AUTH_EMAIL = "SET_AUTH_EMAIL"
export const SET_AUTH_PASSWORD = "SET_AUTH_PASSWORD"
export const SET_TOKEN = "SET_TOKEN"
export const SET_EXPRES_IN = "SET_EXPRES_IN"
export const SET_AUTH = "SET_AUTH"
export const SET_USER = "SET_USER"